<template>
  <div class="c-landing-wrapper c-landing-wrapper js-bukaemas-landing-page u-bg--white">
    <homepage-header @click="showModal" />

    <homepage-benefits />

    <homepage-features />

    <homepage-articles />

    <homepage-start-transaction @click="showModal" />

    <tnc-modal :is-active.sync="isShowModal" />

    <hr style="border-top: 1px solid #ECECEC" />

    <seo-text />
  </div>
</template>
<script>
/* istanbul ignore file */
import meta from 'shared/modules/seo/meta';
import TncModal from 'seo-desktop/components/TncModal';
import SeoText from 'seo-desktop/components/SeoText';
import HomepageHeader from './components/Header';
import HomepageBenefits from './components/Benefits';
import HomepageFeatures from './components/Features';
import HomepageArticles from './components/Articles';
import HomepageStartTransaction from './components/StartTransaction';

export default {
  name: 'LandingPage',

  components: {
    HomepageHeader,
    HomepageBenefits,
    HomepageFeatures,
    HomepageArticles,
    HomepageStartTransaction,
    TncModal,
    SeoText,
  },

  data() {
    return {
      isShowModal: false,
    };
  },

  mounted() {
    document.title = meta.default.title;
  },

  methods: {
    showModal() {
      this.isShowModal = true;
    },
  },
};
</script>
